import SolicitudesPendientes from "../components/SolicitudesPendientes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const PaginaReservacion = () => {
  const navigate = useNavigate();

  return (
    <div className="detalles-cita-container">
      <h1 style={{ marginLeft: "20px" }}>
        <FontAwesomeIcon
          icon={faMagnifyingGlass}
          style={{ marginRight: "8px", color: "#d32f2f" }}
        />
        Datos reservación
      </h1>
      <SolicitudesPendientes />
      <motion.button
        type="button"
        className="agendar2-btn"
        onClick={() => navigate("/")}
        whileTap={{ scale: 0.95 }}
        transition={{ type: "spring", stiffness: 500, damping: 20 }}
        style={{ marginTop: "10px" }}
      >
        Volver
      </motion.button>
    </div>
  );
};

export default PaginaReservacion;
